import { ContentAlignment } from '@varo/graphql-schema-types';

const getVXLAlignment = (alignmentValue: ContentAlignment) => {
  switch (alignmentValue) {
    case ContentAlignment.Center:
      return 'center';
    case ContentAlignment.Trailing:
      return 'flex-end';
    case ContentAlignment.Leading:
      return 'flex-start';
    default:
      return 'center';
  }
};

export { getVXLAlignment };
